import React from 'react'
import line_img from '../../images/lines.png'

const Line = () => <img className='App-line' src={line_img} alt='line' />

export default Line
